module.exports = __webpack_public_path__ + "static/media/Logo white bg.03a8bd97.png";